import { createContext } from 'react';
import { GetDeal_deal_finance_breakdown } from 'src/gql/common/graphql/queries/__generated__/GetDeal';
import IDimensions from '../../../../../common/model/IDimensions';
import { IPriceDisplay } from '../../../../../common/model/IPriceDisplay';

export interface ISummmaryContext {
  dimensions: IDimensions;
  priceDisplay: IPriceDisplay;
  financeDisclaimerBreakdown?: GetDeal_deal_finance_breakdown;
}

const SummaryContext = createContext<ISummmaryContext>({
  dimensions: null,
  priceDisplay: null,
  financeDisclaimerBreakdown: null,
});

export default SummaryContext;
